import { tns } from 'tiny-slider/src/tiny-slider';

export default class HighlightSlider {
  constructor() {
    this.container = document.querySelector('.jsHighlightSlider');
    if (!this.container) return;

    // tiny-slider can't switch between fixedWidth mode and items mode across
    // responsive breakpoints (its getIndexMax closure is fixed at init, so the
    // next button never disables after crossing the boundary) — rebuild instead.
    this.mq = window.matchMedia('(min-width: 1024px)');
    this.mq.addEventListener('change', () => {
      this.slider.destroy();
      this.build();
    });
    this.build();
    this.setWheelEvents();
  }

  // horizontal touchpad scrolling — tiny-slider has no wheel support.
  // Bound to the track (not tns wrappers) so it survives breakpoint rebuilds.
  setWheelEvents() {
    const track = this.container.closest('.highlightSlider__track');
    if (!track) return;

    let acc = 0;
    let locked = false;

    track.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // let vertical scrolling pass
      e.preventDefault();
      if (locked) return;

      acc += e.deltaX;
      if (Math.abs(acc) < 40) return;

      this.slider.goTo(acc > 0 ? 'next' : 'prev');
      acc = 0;
      locked = true; // swallow trackpad inertia so one swipe = one slide
      setTimeout(() => { locked = false; }, 500);
    }, { passive: false });
  }

  build() {
    const common = {
      container: this.container,
      controls: true,
      prevButton: document.querySelector('[data-highlight-slider="buttonLeft"]'),
      nextButton: document.querySelector('[data-highlight-slider="buttonRight"]'),
      nav: false,
      loop: false,
      mouseDrag: true,
      touch: true,
      speed: 500,
    };

    this.slider = tns(this.mq.matches
      ? { ...common, fixedWidth: 414, gutter: 46 }
      : { ...common, items: 1, gutter: 12, responsive: { 768: { items: 2, gutter: 24 } } });
  }
}
